import { TPaymentMethodType } from 'shared/domain/entities';

const STORAGE_KEY = 'checkout:preselectedPaymentMethod';

export function seedPreselectedPaymentMethod(type: TPaymentMethodType): void {
  sessionStorage.setItem(STORAGE_KEY, type);
}

export function consumePreselectedPaymentMethod(): TPaymentMethodType | null {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);

  return (stored as TPaymentMethodType) || null;
}
